import { Kitchen } from './types';

export enum TodoType {
  VIDEO_REVIEW = 'VIDEO_REVIEW'
}

export type VideoReviewSummary = {
  camera: string;
  room?: string | null;
  peopleCount: number;
};

export type TodoItem = {
  id: string;
  type: TodoType;
  kitchen: Kitchen;
  title: string;
  occurredAt: string;
  videoReview?: VideoReviewSummary | null;
};

export type VideoReviewSegment = { action: string; startMs: number; endMs: number; reason?: string | null };

export type VideoReviewPerson = {
  segments: VideoReviewSegment[];
  durationMs: number;
  pastWords: string[];
  rounds: number;
  canGiveWords: boolean;
};

export type VideoReviewLimits = { maxNoteChars: number; maxNoteAudioSeconds: number };

export type VideoReview = {
  id: string;
  digest: string;
  camera: string;
  room?: string | null;
  recordedAt: string;
  people: VideoReviewPerson[];
  maxRevisions: number;
  limits: VideoReviewLimits;
};
